! function () {
	"use strict";

	function C(e) {
		return e.width = "100%", e.height = "auto", '<p>\n              <span class="mce-preview-object mce-object-video" contenteditable="false" \n               data-mce-object="video" data-mce-p-allowfullscreen="allowfullscreen" \n                 data-mce-p-frameborder="no" data-mce-p-scrolling="no" \n                data-mce-p-src='.concat(e.source1, " \n                 data-mce-p-width=")
			.concat(e.width, " \n                 data-mce-p-height=")
			.concat(e.height, ' \n                   data-mce-p-controls="controls" data-mce-html="%20" style="width:100%;">\n                 <video width=')
			.concat(e.width, " height=")
			.concat(e.height, ' controls="controls">\n                          <source src=')
			.concat(e.source1, " ></source>\n                         </video>\n                       </span>\n                    </p>")
	}

	function A(e) {
		for (var t = function (e) {
			for (var t = "", n = 0; n < e.length; n++) {
				var l = e.charCodeAt(n);
				t += 65281 < l && l < 65373 && 65292 != l && 65306 != l && 65307 != l && 65311 != l ? String.fromCharCode(e.charCodeAt(n) - 65248) : e.charAt(n)
			}
			return t
		}(e)
			.split("\n"), n = "", l = 0; l < t.length; l++) {
			var r, a = t[l].trim();
			0 < a.length && (null != (r = /#Format[A-Za-z]+_\d+#/gi.exec(a)) ? (n += r, "" != (a = a.replace(/#Format[A-Za-z]+_\d+#/gi, "")) && (n += "<p>" + a + "</p>\n")) : n += "<p>" + a + "</p>\n")
		}
		return n
	}
	String.prototype.trim = function () {
		return this.replace(/(^[\s]*)|([\s]*$)/g, "")
	};
	var t = function (e) {
		if (!e) {
			return;
		}
		var t = e.selection.getContent(),
			t = function (e, t) {
				var n = [],
					l = [],
					r = [],
					a = [],
					o = [],
					g = !1;
				if (g = t.length ? !0 : g) {
					d = document.createElement("DIV"), g = t, u = (s = (s = e)
						.replace(t, "#SelectHtml"), 0 < window.navigator.userAgent.toLowerCase()
							.indexOf("msie") && (d.innerHTML = d.innerHTML.replace(/<\/p>/gi, "<br /></p>")), d.innerHTML = g.replace(/&nbsp;/gi, ""), []);
					if (null != (h = d.getElementsByClassName("get-cover")) && 0 < h.length) {
						for (v = 0; v < h.length; v++) {
							I = h[v];
							o[o.length] = I.outerHTML, u[u.length] = h[v]
						}
						for (T = 0; T < u.length; T++) {
							var c = h.length;
							h[c - 1].outerHTML = "<p>".concat("#FormatImgID_" + (c - 1) + "get-cover", " </p>")
						}
					}
					if (null != (m = d.getElementsByTagName("TABLE")) && 0 < m.length) {
						for (v = 0; v < m.length; v++) r[r.length] = m[v].outerHTML;
						for (E = 0, v = 0; v < m.length;) m[v].outerHTML = "#FormatTableID_" + E + "#", E++
					}
					if (null != (f = d.getElementsByTagName("OBJECT")) && 0 < f.length) {
						for (v = 0; v < f.length; v++) a[a.length] = f[v].outerHTML;
						for (M = 0, v = 0; v < f.length;) f[v].outerHTML = "#FormatObjectID_" + M + "#", M++
					}
					D = [];
					if (null != (w = d.getElementsByTagName("IMG")) && 0 < w.length) {
						for (v = 0; v < w.length; v++) w[v].parentElement && "get-cover" == w[v].parentElement.className || ((I = document.createElement("IMG"))
							.src = w[v].src, I.width = "100%", I.align = w[v].align, n[n.length] = I, D[D.length] = w[v]);
						for (T = 0; T < D.length; T++) {
							var i = w.length;
							w[i - 1].outerHTML = "<p>".concat("#FormatImgID_" + (i - 1) + "IMG", " </p>")
						}
					}
					H = [];
					if (null != (b = d.getElementsByTagName("VIDEO")) && 0 < b.length) {
						for (v = 0; v < b.length; v++)(I = document.createElement("VIDEO"))
							.src = b[v].src || b[v].childNodes[1].src, I.width = "100%", I.align = b[v].align, l[l.length] = I, H[H.length] = b[v];
						for (T = 0; T < H.length; T++) {
							var p = b.length;
							b[p - 1].outerHTML = "<p>".concat("#FormatVideoID_" + (p - 1) + "VIDEO", " </p>")
						}
					}
					for (_ = 0, B = 0; B < d.getElementsByTagName("b")
						.length; B++) _++;
					for (B = 0; B < d.getElementsByTagName("strong")
						.length; B++) _++;
					if (O = (O = A(d.innerText))
						.replace(/<p>\[ page\]<\/p>/gi, '<div style="page-break-after: always;"><span style="display: none;">&nbsp;</span></div>'), null != r && 0 < r.length)
						for (v = 0; v < r.length; v++) {
							N = r[v];
							O = O.replace("#FormatTableID_" + v + "#", N)
						}
					if (null != a && 0 < a.length)
						for (v = 0; v < a.length; v++) {
							x = "<p>" + a[v] + "</p>";
							O = O.replace("#FormatObjectID_" + v + "#", x)
						}
					if (null != n && 0 < n.length)
						for (v = n.length - 1; 0 <= v; v--) {
							V = '<img src="'.concat(n[v].src, '" alt="')
								.concat(n[v].alt, '" align="')
								.concat(n[v].align, '" border="0"  />');
							O = O.replace("#FormatImgID_" + v + "IMG", V)
						}
					if (null != l && 0 < l.length)
						for (v = l.length - 1; 0 <= v; v--) {
							V = C({
								source1: l[v].src
							});
							O = O.replace("#FormatVideoID_" + v + "VIDEO", V)
						}
					if (null != o && 0 < o.length)
						for (v = o.length - 1; 0 <= v; v--) {
							I = "<p>" + o[v] + "</p>";
							O = O.replace("#FormatImgID_" + v + "get-cover", I)
						}
					for (B = 0; B < _; B++) O = O.replace("#FormatStrongID_" + B + "#", "");
					for (; - 1 != O.indexOf("</p></p>");) O = O.replace("</p></p>", "</p>");
					for (; - 1 != O.indexOf('<p><p align="center">');) O = O.replace('<p><p align="center">', "<p>");
					return g = s.replace("#SelectHtml", O)
				}
				var s, h, m, f, d = document.createElement("DIV"),
					u = (s = (s = e)
						.replace(/<div style="page-break-after: always;?">\s*<span style="display: none;?">&nbsp;<\/span>\s*<\/div>/gi, "<p>[ page]</p>"), d.innerHTML = s.replace(/&nbsp;/gi, ""), 0 < window.navigator.userAgent.toLowerCase()
							.indexOf("msie") && (d.innerHTML = d.innerHTML.replace(/<\/p>/gi, "<br /></p>")), []);
				if (null != (h = d.getElementsByClassName("get-cover")) && 0 < h.length) {
					for (var v = 0; v < h.length; v++) {
						var I = h[v];
						o[o.length] = I.outerHTML, u[u.length] = h[v]
					}
					for (var T = 0; T < u.length; T++) {
						var y = h.length;
						h[y - 1].outerHTML = "<p>".concat("#FormatImgID_" + (y - 1) + "get-cover", " </p>")
					}
				}
				if (null != (m = d.getElementsByTagName("TABLE")) && 0 < m.length) {
					for (var v = 0; v < m.length; v++) r[r.length] = m[v].outerHTML;
					for (var E = 0, v = 0; v < m.length;) m[v].outerHTML = "#FormatTableID_" + E + "#", E++
				}
				if (null != (f = d.getElementsByTagName("OBJECT")) && 0 < f.length) {
					for (var v = 0; v < f.length; v++) a[a.length] = f[v].outerHTML;
					for (var M = 0, v = 0; v < f.length;) f[v].outerHTML = "#FormatObjectID_" + M + "#", M++
				}
				var w, D = [];
				if (null != (w = d.getElementsByTagName("IMG")) && 0 < w.length) {
					for (var v = 0; v < w.length; v++)(I = document.createElement("IMG"))
						.src = w[v].src, I.width = "100%", I.align = w[v].align, n[n.length] = I, D[D.length] = w[v];
					for (var T = 0; T < D.length; T++) {
						var L = w.length;
						w[L - 1].outerHTML = "<p>".concat("#FormatImgID_" + (L - 1) + "IMG", " </p>")
					}
				}
				var b, H = [];
				if (null != (b = d.getElementsByTagName("VIDEO")) && 0 < b.length) {
					for (var v = 0; v < b.length; v++)(I = document.createElement("VIDEO"))
						.src = b[v].src || b[v].childNodes[1].src, I.width = "100%", I.align = b[v].align, l[l.length] = I, H[H.length] = b[v];
					for (var T = 0; T < H.length; T++) {
						var F = b.length;
						b[F - 1].outerHTML = "<p>".concat("#FormatVideoID_" + (F - 1) + "VIDEO", " </p>")
					}
				}
				for (var _ = 0, B = 0; B < d.getElementsByTagName("b")
					.length; B++) _++;
				for (var O, B = 0; B < d.getElementsByTagName("strong")
					.length; B++) _++;
				if (O = (O = A(d.innerText))
					.replace(/<p>\[ page\]<\/p>/gi, '<div style="page-break-after: always;"><span style="display: none;">&nbsp;</span></div>'), null != r && 0 < r.length)
					for (var v = 0; v < r.length; v++) {
						var N = r[v];
						O = O.replace("#FormatTableID_" + v + "#", N)
					}
				if (null != a && 0 < a.length)
					for (var v = 0; v < a.length; v++) {
						var x = "<p>" + a[v] + "</p>";
						O = O.replace("#FormatObjectID_" + v + "#", x)
					}
				if (null != n && 0 < n.length)
					for (var v = n.length - 1; 0 <= v; v--) {
						var V = '<img src="'.concat(n[v].src, '" alt="')
							.concat(n[v].alt, '" align="')
							.concat(n[v].align, '" border="0"  />');
						O = O.replace("#FormatImgID_" + v + "IMG", V)
					}
				if (null != l && 0 < l.length)
					for (var v = l.length - 1; 0 <= v; v--) {
						var V = C({
							source1: l[v].src
						});
						O = O.replace("#FormatVideoID_" + v + "VIDEO", V)
					}
				if (null != o && 0 < o.length)
					for (var v = o.length - 1; 0 <= v; v--) {
						var I = "<p>" + o[v] + "</p>";
						O = O.replace("#FormatImgID_" + v + "get-cover", I)
					}
				for (var B = 0; B < _; B++) O = O.replace("#FormatStrongID_" + B + "#", "");
				for (; - 1 != O.indexOf("</p></p>");) O = O.replace("</p></p>", "</p>");
				for (; - 1 != O.indexOf('<p><p align="center">');) O = O.replace('<p><p align="center">', "<p>");
				return O
			}(e.getContent(), t);
		e.setContent(t)
	};
	tinymce.PluginManager.add("clear-html", function (e) {
		e.ui.registry.addIcon("asdasdasdsa", '<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="design-iconfont"><mask id="lmfqcqv5o__1e4myzbyoa" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><path fill="#D9D9D9" d="M0 0H24V24H0z"/></mask><g mask="url(#lmfqcqv5o__1e4myzbyoa)"><path fill="none" d="M13.8562 17.4131L6.96188 10.5188M20.5152 19.004L12.2119 19.004M12.4848 18.7844L20.7505 10.5188C21.0434 10.2259 21.0434 9.75107 20.7505 9.45817L14.9168 3.62454C14.6239 3.33165 14.1491 3.33165 13.8562 3.62454L3.24957 14.2311C2.95668 14.524 2.95668 14.9989 3.24957 15.2918L6.74221 18.7844C6.88286 18.9251 7.07363 19.0041 7.27254 19.0041H11.9545C12.1534 19.0041 12.3442 18.9251 12.4848 18.7844Z" stroke="#333" stroke-width="1.5" stroke-linecap="round"/></g></svg>'), e.ui.registry.addButton("clear-html", {
			tooltip: "清除格式（多次使用清除更彻底）",
			icon: "asdasdasdsa",
			onAction: function () {
				t(e)
			}
		})
	})
	window.clearHtml = t;
}();